module.exports = __webpack_public_path__ + "img/room-wall.60954e8.jpg";